import { CheckCircle2, Clock, Ban, DollarSign } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import type { UnitStatus } from "@/types/realEstate";

export const getStatusBadge = (status: UnitStatus) => {
  switch (status) {
    case "Available":
      return (
        <Badge className="bg-emerald-600 text-white hover:bg-emerald-700">
          <CheckCircle2 className="w-3 h-3 mr-1" /> Available
        </Badge>
      );
    case "Token_Received":
      return (
        <Badge className="bg-amber-500 text-white hover:bg-amber-600">
          <Clock className="w-3 h-3 mr-1" /> Token Received
        </Badge>
      );
    case "On_Hold":
      return (
        <Badge className="bg-purple-600 text-white hover:bg-purple-700">
          <Clock className="w-3 h-3 mr-1" /> On Hold
        </Badge>
      );
    case "Booked":
      return (
        <Badge className="bg-blue-600 text-white hover:bg-blue-700">
          <DollarSign className="w-3 h-3 mr-1" /> Booked
        </Badge>
      );
    case "Sold":
      return (
        <Badge className="bg-slate-700 text-white hover:bg-slate-800">
          <Ban className="w-3 h-3 mr-1" /> Sold
        </Badge>
      );
    default:
      return <Badge variant="outline">{status}</Badge>;
  }
};
